import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { CandidateService } from './candidate.service';
import { Candidate, CandidateSearchParam } from '../../interfaces/candidate/candidate.interface';
import { environment } from '../../../../../environments/environment.dev';
import { convertToHttpParams } from '../../../../core/interfaces/common-search-param.interface';
import { PageResponse } from '../../../../core/interfaces/page-response.interface';

@Injectable({
    providedIn: 'root'
})
export class CandidateApiService extends CandidateService {
    private http = inject(HttpClient);
    private readonly baseUrl = `${environment.apiBaseUrl}v1/batch/students`;

    constructor() {
        super();
    }

    override findAll(searchParam: CandidateSearchParam): Observable<PageResponse<Candidate>> {
        
        return this.wrapRequest(
            this.http.get<PageResponse<Candidate>>(this.baseUrl, {
                params: convertToHttpParams(searchParam),
                headers: this.headers
            }).pipe(
                map((response: any) => response.response)
            )
        );
    }

    override find(id: string): Observable<Candidate> {
        return this.wrapRequest(
            this.http.get<Candidate>(`${this.baseUrl}/${id}`, { headers: this.headers })
        );
    }

    override create(data: Partial<Candidate>): Observable<Candidate> {
        return this.wrapRequest(
            this.http.post<Candidate>(this.baseUrl, data, { headers: this.headers })
        );
    }

    override update(id: string, data: Partial<Candidate>): Observable<Candidate> {
        return this.wrapRequest(
            this.http.put<Candidate>(`${this.baseUrl}/${id}`, data, { headers: this.headers })
        );
    }

    override delete(id: string): Observable<void> {
        return this.wrapRequest(
            this.http.delete<void>(`${this.baseUrl}/${id}`, { headers: this.headers })
        );
    }
}
